export const FIXED2 = value => {
  return Number.parseFloat(Number.parseFloat(value).toFixed(2));
};

export const FIXED0 = value => {
  return Number.parseFloat(Number.parseFloat(value).toFixed(0));
};
